import api from "./api";


// ============================
// Get Complete About Data
// ============================
export const getAbout = async () => {
  const response = await api.get("/about");

  return response;
};


// ============================
// Get About By ID
// ============================
export const getAboutById = async (id) => {
  const response = await api.get(`/about/about/${id}`);

  return response;
};


// ============================
// Get Skills
// ============================
export const getSkills = async () => {
  const response = await api.get("/about/skills");

  return response;
};


// ============================
// Get Education
// ============================
export const getEducation = async () => {
  const response = await api.get("/about/education");

  return response;
};


// ============================
// Create About
// ============================
export const createAbout = async (data) => {
  const response = await api.post("/about", data);

  return response;
};


// ============================
// Update About
// ============================
export const updateAbout = async (id, data) => {
  const response = await api.put(`/about/about/${id}`, data);

  return response;
};


// ============================
// Delete About
// ============================
export const deleteAbout = async (id) => {
  const response = await api.delete(`/about/about/${id}`);

  return response;
};


// ============================
// Create Skill
// ============================
export const createSkill = async (data) => {
  const response = await api.post("/about/skills", data);

  return response;
};


// ============================
// Update Skill
// ============================
export const updateSkill = async (id, data) => {
  const response = await api.put(`/about/skills/${id}`, data);

  return response;
};


// ============================
// Delete Skill
// ============================
export const deleteSkill = async (id) => {
  const response = await api.delete(`/about/skills/${id}`);

  return response;
};


// ============================
// Bulk Create Skills
// ============================
export const bulkCreateSkills = async (skills) => {
  const response = await api.post("/about/skills/bulk", {
    skills,
  });

  return response;
};


// ============================
// Move Skill Up
// ============================
export const moveSkillUp = async (id) => {
  const response = await api.patch(`/about/skills/${id}/up`);

  return response;
};


// ============================
// Move Skill Down
// ============================
export const moveSkillDown = async (id) => {
  const response = await api.patch(`/about/skills/${id}/down`);

  return response;
};


// ============================
// Create Education
// ============================
export const createEducation = async (data) => {
  const response = await api.post("/about/education", data);

  return response;
};


// ============================
// Update Education
// ============================
export const updateEducation = async (id, data) => {
  const response = await api.put(`/about/education/${id}`, data);

  return response;
};


// ============================
// Delete Education
// ============================
export const deleteEducation = async (id) => {
  const response = await api.delete(`/about/education/${id}`);

  return response;
};


// ============================
// Bulk Create Education
// ============================
export const bulkCreateEducation = async (education) => {
  const response = await api.post("/about/education/bulk", {
    education,
  });

  return response;
};


// ============================
// Move Education Up
// ============================
export const moveEducationUp = async (id) => {
  const response = await api.patch(`/about/education/${id}/up`);

  return response;
};


// ============================
// Move Education Down
// ============================
export const moveEducationDown = async (id) => {
  const response = await api.patch(
    `/about/education/${id}/down`
  );

  return response;
};